import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoMedia from 'theme/promoMedia';

import PromoButtonExtended from '../promo-button/PromoButtonExtended';

const defaultAligning = 'center';

const BtnContainer = styled.div`
    margin-bottom: 32px;
    text-align: ${(props) => props.aligning || defaultAligning};

    ${promoMedia.tablet744} {
        margin-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        margin-bottom: 64px;
        text-align: ${(props) => (props.desktopAlignLeft ? 'left' : props.aligning || defaultAligning)};
    }
`;

const LoneButtonSection = (props) => {
    return (
        <>
            {props.btn && (
                <BtnContainer aligning={props.aligning} desktopAlignLeft={props.desktopAlignLeft}>
                    <PromoButtonExtended
                        btn={props.btn}
                        btnMobile={props.btnMobile}
                        isMobileBtn={props.isMobileBtn}
                        iconName={props.iconName}
                        variant={props.variant}
                        sendFrom={props.sendFrom}
                        isInverted={props.isInverted}
                    />
                </BtnContainer>
            )}
        </>
    );
};

LoneButtonSection.propTypes = {
    aligning: PropTypes.oneOf(['left', 'right', 'center']),
    btn: PropTypes.object,
    btnMobile: PropTypes.object,
    iconName: PropTypes.string,
    isMobileBtn: PropTypes.bool,
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    desktopAlignLeft: PropTypes.bool,
    isInverted: PropTypes.bool,
};

export default LoneButtonSection;
